import clsx from 'clsx';

const ScrollIndicator = ({ indicator, className, trackClassName, thumbClassName }) => {
  if (!indicator?.show) return null;

  return (
    <div
      className={clsx(
        'relative overflow-hidden pointer-events-none rounded-full bg-gray-200/70',
        trackClassName,
        className
      )}
      aria-hidden="true"
    >
      <div
        className={clsx(
          'absolute inset-y-0 rounded-full transition-all duration-150 ease-out bg-gray-600',
          thumbClassName
        )}
        style={{
          width: `${indicator.width}%`,
          left: `${indicator.left}%`,
        }}
      />
    </div>
  );
};

export default ScrollIndicator;
